// extracted by mini-css-extract-plugin
export default {"advertCardHeader":"c-a_ja","advertCardHeader__actions":"c-a_jb","advertCardHeader__bottomLabel":"c-a_jc"};